import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, userRole, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/management/agentdetails/loadscreenview", { id, userRole }, successCallback, failureCallback);
    },
    getPartnerByEmail: (email, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/edit/getpartnerbyemail", { email }, successCallback, failureCallback);
    },
    addAgent: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/management/agentdetails/add", vo, successCallback, failureCallback);
    },
    updateAgent: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/management/agentdetails/update", vo, successCallback, failureCallback);
    },
    getAllCountryCode: (successCallback, failureCallback) => {
        ApiService.post("/default/getcountrycode", null , successCallback, failureCallback);
    },
};

export default EditService;